// @ts-nocheck
import angular from 'angular';
import {useToken} from 'acng/userPool/service/token.js';
import {logger} from 'acng/Lib/Log/client';

angular.module('core').factory('logger', [
  '$rootScope',
  'user',
  'onsLaForgeClient',
  'LaForge',
  ($rootScope, user, onsLaForgeClient, LaForge) => {
    const client = logger;
    return client.log.bind(client);
  },
]);
